<template>
	<div
		class="device"
		v-loading="deviceLoading"
		element-loading-text="加载中"
		element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.9)"
	>
		<div v-if="!deviceInfo.id" class="nullData">暂无数据</div>
		<div v-else>
			<div class="device-title">
				<div class="leftBox">设备详细信息</div>
				<div class="rightBox">
					<img @click="closeDevice" src="@/assets/imgs/visitCloseBtn.png" alt="" />
				</div>
			</div>
			<div class="device-context">
				<div class="deviceInfo">
					<div class="imgs">
						<span>{{ deviceInfo.nature }}</span>
						<img v-if="deviceInfo.img" class="w100 h100" :src="deviceInfo.img" alt="" />
					</div>
					<div class="infos">
						<p class="name">{{ deviceInfo.name }}</p>
						<p class="type"><span>设备类型：</span>{{ deviceInfo.type }}</p>
						<p class="nature"><span>性&emsp;&emsp;质：</span>{{ deviceInfo.nature }}</p>
						<p class="practiceUnit"><span>所属单位：</span>{{ deviceInfo.ownerOrganizationName }}</p>
						<p class="person"><span style="letter-spacing: 4px">负责人：</span>{{ deviceInfo.principalName }}</p>
						<p class="phone"><span style="letter-spacing: 0.7px">联系电话：</span>{{ deviceInfo.phoneNumber }}</p>
					</div>
				</div>
				<div class="certificate">
					<div class="flexImg" v-if="deviceInfo.otherImgs.length > 0">
						<img v-for="item in deviceInfo.otherImgs" :key="item.url" :src="item.url" alt="" />
					</div>
					<div class="nullImgData" v-else>未上传设备详情图片</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			deviceLoading: false,
			deviceInfo: {},
		};
	},
	props: {
		discriminationCode: {
			type: String,
			default: 'T',
		},
	},
	methods: {
		closeDevice() {
			this.$emit('closeDevice');
		},
		// 获取数据
		getData(data) {
			if (!data.id) return this.$message.error('数据错误，请联系管理员');
			this.personLoading = true;
			this.$http
				.get(`/management-api/v1/Devices/${data.item.id}.json`)
				.then((res) => {
					if (res.data && res.data.success) {
						this.personLoading = false;
						let data = res.data.collection[0] || {};
						this.deviceInfo = data;
						this.deviceInfo.img =
							(data.attachmentDtoMap && data.attachmentDtoMap['DETAILPHOTO'] && data.attachmentDtoMap['DETAILPHOTO'][0].link) || '';
						this.deviceInfo.type = data.modelDictionaryItem?.title || '';
						this.deviceInfo.nature = data.characterDictionaryItem?.title || '';
						this.deviceInfo.otherImgs =
							(
								data.attachmentDtoMap &&
								data.attachmentDtoMap['DETAILPHOTO'] &&
								data.attachmentDtoMap['DETAILPHOTO'].map((v) => {
									return {
										url: v.link,
									};
								})
							).splice(1) || [];
					}
				})
				.catch((err) => {});
		},
	},
};
</script>

<style lang="scss" scoped>
.device {
	width: 500px;
	height: 460px;
	overflow: auto;
	background: url('../../../../assets/imgs/visitGroupBg.png') no-repeat center;
	background-size: 100% 100%;
	position: relative;
	&-title {
		height: 52px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 25px;
		background: url('../../../../assets/imgs/dialogTitleBg.png') no-repeat center;
		background-size: 100% 100%;
		color: #fff;
		.leftBox {
			margin-top: 6px;
			font-size: 22px;
			font-family: PangMenZhengDao;
			line-height: 22px;
			height: 25px;
			background: url('../../../../assets/imgs/线.png') no-repeat bottom;
			background-size: 100% 5px;
		}
		.rightBox {
			margin-top: 6px;
			img {
				width: 28px;
				height: 28px;
				cursor: pointer;
			}
		}
	}
	&-context {
		.deviceInfo {
			padding: 16px 20px;
			display: flex;
			justify-content: space-between;
			border-bottom: 2px solid #153b6c;
			.imgs {
				background: #0a2951;
				border: 1px solid #274271;
				border-radius: 6px;
				position: relative;
				width: 180px;
				height: 180px;
				margin-right: 16px;
				span {
					display: inline-block;
					padding: 0 5px;
					text-align: center;
					line-height: 24px;
					color: #fff;
					background-color: #1fcfc0;
					border-radius: 6px 0 6px 0;
					position: absolute;
					top: 0;
					left: 0;
				}
			}
			.infos {
				flex: 1;
				color: #fff;
				p {
					font-size: 14px;
					line-height: 14px;
					height: 14px;
					margin-bottom: 16px;
					&:last-child {
						margin-bottom: 0;
					}
				}
				.name {
					font-size: 16px;
					line-height: 16px;
					height: 16px;
					margin-bottom: 25px;
					font-weight: bold;
				}
			}
		}
		.certificate {
			padding: 15px 18px;
			.flexImg {
				display: flex;
				justify-content: space-between;
				align-items: center;
			}
			img {
				width: 145px;
				height: 160px;
				&:last-child {
					margin-right: 0;
				}
			}
			.nullImgData {
				width: 100%;
				color: #fff;
				text-align: center;
			}
		}
	}
	.nullData {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		color: #fff;
		font-size: 16px;
	}
}
</style>